import { pick } from 'ramda';
import React, { memo } from 'react';
import { Loader } from 'js/components/common/Loader';

import { GamesCategory } from '../GamesCategory';
import { GamesContentEmpty } from '../GamesContentEmpty';
import { useDynamicReducerSelector } from '../../store';

import style from './GamesContent.scss';

export const GamesContentBare: React.FC = () => {
    const { isLoading, gamesFeed } = useDynamicReducerSelector(pick(['isLoading', 'gamesFeed']));

    return (
        <div className='cms-games-grid-content'>
            {!isLoading ? (
                <>
                    <div className={`${style.gamesGridCategories} cms-games-grid-categories`}>
                        {
                            gamesFeed?.gamesFeedCategories.map((category) => (
                                <GamesCategory key={category.name} categoryName={category.name} feedName={gamesFeed.name} />
                            ))
                        }
                    </div>
                    <GamesContentEmpty className={style.emptyContent} />
                </>
            ) : (
                <Loader />
            )}
        </div>
    );
};

export const GamesContent = memo(GamesContentBare);
